import React from 'react';
import Select from 'components/forms/Select';
import Error from 'components/forms/Error';

const RenderSelectInput = props => (
  <React.Fragment>
    <Select
      {...props}
      defaultOptions
      cacheOptions
      isClearable={props.isClearable || false}
      placeholder={props.placeholder || 'Select...'}
      value={props.input.value || ''}
      onBlur={() => props.input.onBlur(props.input.value)}
      onChange={props.handleChange || props.input.onChange}
      loadOptions={props.getOptions}
      isDisabled={props.disabled}
      options={props.options}
      onInputChange={props.onInputChange}
      displayProperty={props.displayProperty}
    />
    {props.meta.touched &&
    ((props.meta.error && <Error error={props.meta.error} />))}
  </React.Fragment>
);

export default RenderSelectInput;
